<template>
  <div class="row"  v-if="permissao" >
    <div class="col-xs-12">
      <div class="cabecalho">
        <!-- Select group contract SLA -->
        <div class="form-inline">
          <div class="row">
            <!-- Select State -->
            <div class="form-group col-md-3">
              <label> UF: </label>
              <select class="form-control" v-model="ufSelecionada" @change="onChangeFiltro()">
                <option v-for="uf in ufs" :value='uf.id' >{{ uf.nome }}</option>
              </select>
            </div>

            <!-- Select Contract -->
            <div class="form-group col-md-4">
              <label> Contrato: </label>
              <select class="form-control" align="center" v-model="contratoSelecionado" @change="onChangeFiltro()">
                <option v-for="i in tipo_imovel_servicos" :value='i' >{{ i.nome }}</option>
              </select>
            </div>

            <!-- Select Month -->
            <div class="form-group col-md-3">
              <label> Mês: </label>
              <select class="form-control" v-model="mesSelecionado" @change="onChangeFiltro()">
                  <option v-for="mes in meses" :value="mes">{{ mes.nome }}</option>
              </select>
            </div>

            <!-- Select Year -->
            <div class="form-group col-md-2">
              <label> Ano: </label>
              <select class="form-control" v-model="anoSelecionado" @change="onChangeFiltro()">
                <option v-for="i in anos" >{{ i.ano }}</option>
              </select>
            </div>
            
            <div class="form-group clear-buton col-md-12" align="right">
              <button
                class="btn btn-default"
                variant="primary"
                v-on:click="limparFiltro()"
                > Limpar Filtro
              </button>
            </div>
          </div>
        </div> <!-- ./form-inline -->
      </div>

      <br> 

      <div class="box box-default">
        <div class="box-header with-header">
          <h3>Notificações</h3>
        </div>
        <div class="box-body table-responsive no-padding" v-if="notificacoes != ''">
          <table class="table table-hover">
            <tbody>
              <tr>
                <th class="text-center">ID</th>
                <th class="text-center">Estado</th>
                <th class="text-center">Contrato</th>
                <th class="text-center">Mês</th>
                <th class="text-center">Ano</th>
                <th class="text-center">Data de Envio</th>
                <th class="text-center">Retorno Fornecedor</th>
            </tr>
            <tr v-for="(notificacao,index) in records" :key="notificacao.id" v-bind:key="notificacao.id" v-if="index + 1 >= startIndex && index + 1 <= endIndex" >
              <td class="text-center"><a title="Detalhes notificação" href='javascript:void(0)' v-on:click="detalhesNotificacao(notificacao.id)">{{notificacao.id}}</a></td>
              <td class="text-center">{{ notificacao.uf }}</td>
              <td class="text-center">{{ notificacao.tipo_imovel_servico }}</td>
              <td class="text-center">{{ notificacao.sigla }}</td>
              <td class="text-center">{{ notificacao.ano_referencia }}</td>
              <td class="text-center">{{ notificacao.data_envio }}</td>
              <td v-if="notificacao.status_resposta === 'Concorda'" class="text-center">
                <span class="label label-success">{{ notificacao.status_resposta }}</span>
              </td>
              <td v-else-if="notificacao.status_resposta === 'Sem resposta'" class="text-center">
                <span class="label label-warning">{{ notificacao.status_resposta }}</span>
              </td>
              <td v-else class="text-center">
                <span class="label label-danger">{{ notificacao.status_resposta }}</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <h4 class="form-inline" v-if="this.filtro == null"> Você não possui notificação. </h4>
          <h4 class="form-inline" v-else> Você não possui notificação filtrada. </h4>
        </div>
        <div align="center"><pagination :records="recordsLength"  v-model="page" :per-page="perPage" @paginate="getPage"></pagination></div>
         <!-- <div class="box-footer">
            <button
              class="btn btn-historico btn-default"
              variant="primary"
              data-toggle="modal"
              v-on:click="listarHistoricoNotificacoes()"
              data-target="#modalHistoricoNotificacoes">Histórico
            </button>
        </div> -->
      </div>
    </div>
  </div>

</template>

<script>
import Pagination from 'vue-pagination-2'

export default {
  data () {
    return {
      page: 1,
      startIndex: 1,
      endIndex: 15,
      perPage: 15,
      records: [],
      recordsLength: 0,
      env: process.env,
      notificacoes: null,
      historicoNotificacoes: [],
      ufs: [],
      tipo_imovel_servicos: [],
      anos: [],
      meses: [],
      ufSelecionada: null,
      contratoSelecionado: null,
      mesSelecionado: null,
      anoSelecionado: null,
      filtro: null,
      gruposPermitidos: ['oi', 'admin'],
      permissao: true
    }
  },
  components: {
    Pagination
  },
  mounted: function () {
    this.getGrupos()
    // Array com grupos do usuário
    let usuarioGrupo = this.$store.state.login.loginUsuario.grupo
    // msg(setPermissaoNegada) - função verificando se o usuário possui mais de um grupo(max 3)
    let msgGrupos = usuarioGrupo[0].nome
    if (usuarioGrupo[1]) {
      msgGrupos = usuarioGrupo[0].nome + ' ,' + usuarioGrupo[1].nome
      if (usuarioGrupo[2]) {
        msgGrupos = usuarioGrupo[0].nome + ' ,' + usuarioGrupo[1].nome + ' ,' + usuarioGrupo[2].nome
      }
    }
    // console.log(msgGrupos)
    // if (this.gruposPermitidos.indexOf(usuarioGrupo) === -1) {
    // if (this.usuarioGrupo.includes('admin') === true || this.usuarioGrupo.includes('oi') === true) {
    if (usuarioGrupo.find(permissao => permissao.nome === 'oi' || permissao.nome === 'admin')) {
      this.getNotificacao()
      this.getPage(this.page)
      this.getUfsDoUsuario()
      this.getTipoImovelServico()
      this.getAno()
      this.getMes()
    } else {
      this.permissao = false
      this.$store.commit('setPermissaoNegada', {msg: `Seu grupo de usuáro [ ${msgGrupos} ] não permisse acesso a esta área.`, status: false, show: true})
    }
  },
  methods: {
    detalhesNotificacao: function (idNotificacao) {
      this.$router.push(`/ExibirNotificacao/?id=${idNotificacao}`)
    },
    getPage: function (page) {
      // we simulate an api call that fetch the records from a backend
      let startIndex = this.perPage * (page - 1) + 1
      let endIndex = startIndex + this.perPage - 1
      this.startIndex = startIndex
      this.endIndex = endIndex
      if (this.notificacoes !== null) {
        // for (let i = startIndex; i <= endIndex; i++) {
        this.records = this.notificacoes
        // }
      }
    },
    getNotificacao () {
      let parametros = {
        grupo: this.$store.state.login.loginUsuario.grupo,
        estado: this.$store.state.login.loginUsuario.estado,
        contrato: this.$store.state.login.loginUsuario.contrato,
        filtro: this.filtro
      }

      let vm = this
      this.$axios.post(`${this.env.FINANCEIRO.NOTIFICACAO}/getnotificacao`, parametros, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      }).then(function (response) {
        if (response.status === 200 || response.status === 201) {
          vm.notificacoes = response.data
          vm.records = response.data
          vm.recordsLength = response.data.length
        } else {
          vm.$store.commit('setAlert', {msg: response.data.erro, status: false, show: true})
        }
      })
    },
    listarHistoricoNotificacoes () {
      let parametros = {
        grupo: this.$store.state.login.loginUsuario.grupo,
        estado: this.$store.state.login.loginUsuario.estado,
        contrato: this.$store.state.login.loginUsuario.contrato
      }
      this.$store.commit('setHistoricoNotificacoes', parametros)
    },
    getUfsDoUsuario () {
      this.ufs = this.$store.state.login.loginUsuario.estado
    },
    getTipoImovelServico () {
      let vm = this
      this.$axios.get(`${this.env.FINANCEIRO.SLA}/gettipoimovelservico`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      })
      .then(function (response) {
        vm.tipo_imovel_servicos = response.data
      })
    },
    getAno () {
      let vm = this
      this.$axios.get(`${this.env.FINANCEIRO.SLA}/getano`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      })
      .then(function (response) {
        vm.anos = response.data
      })
    },
    getMes () {
      let date = new Date()
      this.mes_atual = date.getMonth()
      let vm = this
      this.$axios.get(`${this.env.FINANCEIRO.SLA}/getmes`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      }).then(function (response) {
        vm.meses = response.data
      })
    },
    onChangeFiltro () {
      this.filtro = {
        ufSelecionada: this.ufSelecionada,
        contratoSelecionado: this.contratoSelecionado,
        mesSelecionado: this.mesSelecionado,
        anoSelecionado: this.anoSelecionado
      }

      this.page = 1
      this.getNotificacao()
    },
    limparFiltro () {
      this.filtro = null
      this.ufSelecionada = null
      this.contratoSelecionado = null
      this.mesSelecionado = null
      this.anoSelecionado = null

      this.page = 1
      this.getNotificacao()
    },
    getGrupos () {
      let grupos = []
      this.$store.state.login.loginUsuario.grupo.forEach(function (element) {
        grupos.push(element.nome)
      })
      this.usuarioGrupos = grupos
    }
  }
}
</script>

<style scoped>
h2 {
  margin-bottom: .5em;
}

select, label {
  display: block;
}

.form-inline {
  padding: 1em;
}

.cabecalho {
  margin-top: 15px;
  background-color: #dbdeec;
  padding: 1em;
  border-radius: 0.5em;
}

.clear-buton {
  margin-top: 1em;
}

</style>



// WEBPACK FOOTER //
// ListarNotificacoes.vue?38297b54